import type { ApiEndpointDefinition } from './api-endpoint.types';
import { AUTH_ENDPOINTS } from './endpoints/auth.endpoints';
import { DEALER_OPENAPI_ENDPOINTS } from './endpoints/dealer-openapi.endpoints';
import { EVENT_ENDPOINTS } from './endpoints/events.endpoints';
import { PAGE_ENDPOINTS } from './endpoints/pages.endpoints';
import { PATROL_ENDPOINTS } from './endpoints/patrol.endpoints';
import { RESOLVE_OPENAPI_ENDPOINTS } from './endpoints/resolve-openapi.endpoints';
import { SITE_ENDPOINTS } from './endpoints/sites.endpoints';

/**
 * Single registry of all Agent API + page bootstrap endpoints.
 * Domain slices live under `./endpoints/`; import `API_ENDPOINTS` from `api-endpoints`.
 */
export const API_ENDPOINTS = {
  ...EVENT_ENDPOINTS,
  ...PATROL_ENDPOINTS,
  ...SITE_ENDPOINTS,
  ...AUTH_ENDPOINTS,
  ...PAGE_ENDPOINTS,
  ...DEALER_OPENAPI_ENDPOINTS,
  ...RESOLVE_OPENAPI_ENDPOINTS,
} as const satisfies Record<string, ApiEndpointDefinition>;

export type ApiEndpointId = keyof typeof API_ENDPOINTS;

export const API_ENDPOINT_LIST: ApiEndpointDefinition[] = Object.values(API_ENDPOINTS);

export const apiEndpointById = (id: ApiEndpointId): ApiEndpointDefinition => API_ENDPOINTS[id];
